// 1. Import the extendTheme function
import { extendTheme } from '@chakra-ui/react';
import { colors } from './colors';
import { fonts } from './fonts';

export const theme = extendTheme({ colors, fonts });
